module.exports = __webpack_public_path__ + "static/media/picnicker-silver-yeti.808cfade.png";